<template>
    <div v-if="dialogVisible" class="dialog__wrapper" >
        <div class="back-btn" @click="closeDialog">
            <div class="arrow" >
                <img src="@/assets\images\busImage\back.png">
            </div>
        </div>
        <div v-if="isDelBtn" class="del-btn" >
            <div v-if="type === 'blank'" class="cancle-button" @click="addOrigin">添加至原文件中</div>
            <div v-else class="arrow" @click="delImage">
                <img src="@/assets\images\busImage\delete.png">
            </div>
        </div>
        <div class="left-btn" @click="previous">
            <div class="arrow-big" >
                <img src="@/assets\images\busImage\arrow_left.png">
            </div>
        </div>
        <div class="right-btn" @click="nextImage">
            <div class="arrow-big last-arrow" >
                <img src="@/assets\images\busImage\arrow_right.png">
            </div>
        </div>
        <div class="image-block" ref="imgCont" @click.self="closeDialog">
            <img 
                class="preview-image"
                ref="imgDiv"
                :style="imageStyle"
                :src="curImage.url"
                object-fit="contain"
                @touchstart="moveImg($event)"
            />
        </div>
        <div class="footer">
            <div class="arrow" @click="amplifyImage">
                <img src="@/assets\images\busImage\amplify.png">
            </div>
            <div class="arrow" @click="reduceImage">
                <img src="@/assets\images\busImage\reduce.png">
            </div>
            <div class="num"> {{curIndex+1}} / {{imgList.length}}</div>
            <div class="arrow" @click="turnLeft">
                <img src="@/assets\images\busImage\left_turn.png">
            </div>
            <div class="arrow" @click="turnRight">
                <img src="@/assets\images\busImage\right_turn.png">
            </div>
        </div>
        <tipsDialog :dialogVisible="tipsDialogVisible" :tipsMessage="tipsMessage" @handleClose="closeTipsDialog">
            <div class="btn-group">
                <div class="cancle-btn" @click="closeTipsDialog">取消</div>
                <div class="confirm-btn" @click="confirmDel">确认</div>
            </div>
        </tipsDialog>
        <el-dialog
            :visible.sync="addDialogVisible"
            append-to-body
            top="40vh"
            width="800px"
            :show-close="false">
            <div class="confirm-content">
                <div class="info">
                   <img src="@/assets/images/busImage/confirm.png"/>
                   <div class="tips">已添加</div>
                </div>
            </div>
        </el-dialog>
        <div v-if="showTips" class="animated-tip"><i class="el-icon-warning-outline"></i>点击空白处将关闭弹窗</div>
    </div>
</template>
<script>
import tipsDialog from '@/components/tipsDialog'
import { delImage, setImgAngle } from '@/api/fileScan'
import { debounce } from 'lodash'
export default {
    components: {tipsDialog},
    props: {
        isDelBtn: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return {
            rotation:0,
            scale:1,
            dialogVisible: false,
            imgList: [],
            curIndex: '',
            curImage: '',
            // 提示弹窗
            tipsDialogVisible:false,
            tipsMessage: '图片删除后将无法恢复，是否继续删除？',
            type: '', // 预览的类型：null 正常预览，blank: 空白页
            addDialogVisible: false,
            showTips: true
        }
    },
    computed: {
        imageStyle() {
            return {
                transform: `translate(-50%, -50%) scale(${this.scale}) rotate(${this.rotation}deg)`,
            };
        }
    },
    methods: {
        openDialog(imgList,curIndex, type){
            this.dialogVisible = true
            this.scale = 1
            this.imgList = imgList
            this.curIndex = curIndex
            this.curImage = imgList[curIndex]
            this.rotation = imgList[curIndex].rotation || 0
            this.type = type

            this.showTips = true
            let timer = setTimeout(() => {
                this.showTips = false
                clearTimeout(timer)
            }, 3000)
        },
        closeDialog(){
            this.dialogVisible = false
        },
        previous(){
            this.scale = 1
            if(this.curIndex === 0){
                this.curIndex = this.imgList.length -1
            }else {
                this.curIndex -= 1
            }
            this.curImage = this.imgList[this.curIndex]
            this.rotation = this.curImage.rotation || 0
        },
        nextImage(){
            this.scale = 1
            if(this.curIndex === this.imgList.length -1){
                this.curIndex = 0
            }else {
                this.curIndex += 1
            }
            this.curImage = this.imgList[this.curIndex]
            this.rotation = this.curImage.rotation || 0
            
        },
        delImage(){
            this.tipsDialogVisible = true
        },
        turnLeft(){
            this.rotation -= 90
            this.setRotationAngle()
        },
        turnRight(){
            this.rotation += 90
            this.setRotationAngle()
        },
        setRotationAngle: debounce(function () {
            this.setAngle();
        },1000),
        async setAngle(){
            let fileId = this.curImage.fileId
            this.$emit('rotationImage',this.curImage.imgIndex,this.rotation)
            if(fileId){
                await setImgAngle({id:fileId,angle:this.rotation})
            }else {
                console.log('-----图片没有上传完成')
            }
        },
        amplifyImage(){
            this.scale +=0.1
        },
        reduceImage(){
            this.scale -=0.1
        },
        // 图片移动
        moveImg (e) {
            // 获得该时间触发的时间戳
            let mouseDate = new Date().getTime();
            this.$emit('getMouseDate', mouseDate)
            e.preventDefault()
            // 获取元素
            let imgWrap = this.$refs.imgCont
            let img = this.$refs.imgDiv
            let x = e.targetTouches[0].pageX - img.offsetLeft
            let y = e.targetTouches[0].pageY - img.offsetTop
            // 添加手指移动事件
            imgWrap.addEventListener('touchmove', move)
            function move (e) {
                img.style.left = e.targetTouches[0].pageX - x + 'px'
                img.style.top = e.targetTouches[0].pageY - y + 'px'
            }   
            // 将事件移除
            img.addEventListener('touchend', () => {
                imgWrap.removeEventListener('touchend', move)
            })
            // 手指离开父级元素，把事件移除
            imgWrap.addEventListener('touchend', () => {
                imgWrap.removeEventListener('touchend', move)
            })
        },
        closeTipsDialog(){
            this.$message('已取消');
            this.tipsDialogVisible = false
        },
        confirmDel(){
            delImage({fileIds:[this.curImage.fileId]}).then(res => {
                if(res.code === 200){
                    this.tipsDialogVisible = false
                    this.dialogVisible = false
                    this.$message.success('删除成功');
                    this.$emit('delImage',this.curImage.imgIndex)
                }
            })
        },
        // 添加至原始凭证
        addOrigin(){
            this.$emit('addOrigin',this.curIndex)
            this.imgList.splice(this.curIndex-1, 1)
            this.addDialogVisible = true
            setTimeout(() => {
                if(this.imgList.length <= 0){
                    this.dialogVisible = false
                }else {
                    if(this.curIndex >= this.imgList.length){
                        this.$nextTick(() => {
                            this.previous()
                        },100)
                        
                    }else {
                        // this.nextImage()
                    }
                }
                this.addDialogVisible = false
            },1000)
        }
    }
}
</script>
<style lang="less" scoped>
    .image-block {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        .preview-image{
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            cursor: move;
            margin: 0 auto;
        }
    }
    .arrow {
        width: 66px;
        height: 66px;
        margin-right: 50px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 50%;
        color:  #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            height: 33px;
            width: 33px;
        }
    }
    .cancle-button {
            display: inline-block;
            padding: 20px 20px;
            background: #FFEEF1;
            border-radius: 8px;
            border: 2px solid #F7636E;
            font-size: 28px;
            color: #F7636E;
        }
    .arrow-big{
        width: 86px;
        height: 86px;
        margin-right: 50px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 50%;
        color:  #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            height: 55px;
            width: 55px;
        }
    }
    .dialog__wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 100;
        overflow: auto;
        margin: 0;
        background-color: rgba(0, 0, 0, 0.5);
        .back-btn {
            position: absolute;
            z-index: 100;
            left: 50px;
            top: 50px;
        }
        .del-btn {
           position: absolute;
           z-index: 100;
           right:50px;
           top: 50px; 
        }
        .left-btn {
            position: absolute;
            z-index: 100;
            left:50px;
            top: 45%; 
        }
        .right-btn {
            position: absolute;
            z-index: 100;
            right:50px;
            top: 45%; 
        }
        .footer {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: calc(100% - 80px);
            left: 50%;
            transform: translate(-50%,-50%);
            .last-arrow {
                margin-right: 0;
            }
            .num {
                margin-right: 40px;
                color: #FFFFFF;
                font-size: 24px;
            }
        }
        .sidebar {
            position: absolute;
            right: 210px;
            top: 65%;
            .arrow {
                width: 66px;
                height: 66px;
                margin-bottom: 50px;
                background: #FFFFFF;
                border-radius: 50%;
                color: #F7636E;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    height: 33px;
                    width: 33px;
                }
            }
        }
    }
    .confirm-content {
        .info {
            display: flex;
            flex-direction: row;
            justify-content: center;
            img {
                height: 56px;
                width: 56px;
            }
            .tips {
                margin-left: 12px;
                margin-top: 5px;
                font-weight: 500;
                font-size: 32px;
                color: rgba(0,0,0,0.85);
            }
        }
        
    }
    .animated-tip {
        position: absolute;
        z-index: 100;
        top: calc(100% - 150px);
        left: 30px;
        color: #FFFFFF;
        padding: 20px 30px;
        font-weight: bold;
        font-size: 16px;
        letter-spacing: 2px;
        animation: bounce 1s infinite;
    }
        
    @keyframes bounce {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-10px);
        }
    }
</style>

